import axios from 'axios';
import { API_BASE_URL } from '../api';

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export async function pollGenerationJob(jobId, token, { pollIntervalMs = 3000, maxWaitMs = 8 * 60 * 1000 } = {}) {
  const deadline = Date.now() + maxWaitMs;
  let lastError = null;

  while (Date.now() < deadline) {
    await sleep(pollIntervalMs);
    try {
      const res = await axios.get(`${API_BASE_URL}/jobs/${jobId}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        timeout: 20000,
      });
      const job = res.data?.data;
      if (job?.status === 'completed') return job.result;
      if (job?.status === 'failed') {
        const message = job.error || 'Generation failed';
        const error = new Error(message);
        error.response = { status: 500, data: { success: false, message } };
        throw error;
      }
    } catch (error) {
      if (error.response?.data?.success === false) throw error;
      lastError = error;
    }
  }

  const error = new Error(
    lastError?.response?.data?.message ||
      lastError?.message ||
      'Generation is taking longer than expected. Please check again in a moment.'
  );
  error.code = 'ECONNABORTED';
  throw error;
}

export async function postGenerationJob(url, payload, { token, timeout = 30000, maxWaitMs = 8 * 60 * 1000 } = {}) {
  const authToken = token || (typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null);
  const startRes = await axios.post(url, payload, {
    headers: {
      'Content-Type': 'application/json',
      ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
    },
    timeout,
    validateStatus: (status) => status >= 200 && status < 300,
  });

  const body = startRes.data;
  const jobId = body?.data?.jobId;
  if (startRes.status === 202 && jobId && body?.data?.status === 'queued') {
    return pollGenerationJob(jobId, authToken, { maxWaitMs });
  }
  return body;
}
